module.exports = __webpack_public_path__ + "img/003.be461b16.jpg";